module.exports = __webpack_public_path__ + "assets/ec02e05b20a2882d0a75e7b9cd3cba80.png";